module.exports = "<div\n  right-click=\"grid.appScope.onRightClick($event)\"\n  ng-repeat=\"(colRenderIndex, col) in colContainer.renderedColumns track by col.uid\"\n  ui-grid-one-bind-id-grid=\"rowRenderIndex + '-' + col.uid + '-cell'\"\n  class=\"ui-grid-cell\"\n  ng-class=\"{ 'ui-grid-row-header-cell': col.isRowHeader }\"\n  role=\"{{col.isRowHeader ? 'rowheader' : 'gridcell'}}\"\n  ui-grid-cell>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./client/app/journal/journal.tableRow.html
// module id = 60
// module chunks = 0